import { useMutation } from '@apollo/client';
import { Campaign } from '../../shared/types';
import { UpdateCampaignRequest, UpdateCampaignResponse, CITRIN_UPDATE_CAMPAIGN } from '..';

type UpdateMutationFunction = (request: Campaign) => Promise<Campaign>;
export const useUpdateCampaignMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdateCampaignResponse, UpdateCampaignRequest>(CITRIN_UPDATE_CAMPAIGN);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updateCampaign;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
